import { MessageBox, Message,Alert } from 'element-ui'
import store from '@/store'
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
//判断空值
function checkNull(str){
  if(str==null||str==""||String(str).trim()==""){
    return true
  }
  return false
}

//showMessage
function showMessage(str,type) {
  Message({
    message: str,
    type: type,
    center: true,
    duration:2500,
  });
}

/**
 *show简易的信息提示框
 * @param str message
 * @param title title
 * @param type type success / info / warning / error
 */
function showEasyMessageBox(str,title,type) {
  MessageBox({
    message:str,
    title:title,
    type:type,
  })

}

/**
 * 从浏览历史页面中移除当前页面，适用于保存成功 需要 关闭当前页面的情况，
 * @param view 当前路由对象， 一般情况下 传入  this.$route 即可
 */
function closeCurrentPage(view) {
  return new Promise((resolve, reject) => {
    store.dispatch('delView', view).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

function exportExcel(ref,name) {
  showMessage('正在导出中~','success')
  try {
    const $e = ref.$el
    let $table = $e.querySelector('.el-table__fixed')
    if(!$table) {
      $table = $e
    }
    const wb = XLSX.utils.table_to_book($table, {raw:true})
    const wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST:true, type: 'array'})
    FileSaver.saveAs(
      new Blob([wbout],{type: 'application/octet-stream'}),
      `${name}.xlsx`,
    )
  } catch (e) {
    if (typeof console !== 'undefined') console.error(e)
  }
}


export  default {
  checkNull,
  showMessage,
  showEasyMessageBox,
  closeCurrentPage,
  exportExcel
}
